import { getTerritory } from 'api/account'
export const addressMixin = {
    data () {
        return {
            provinceList: [],
            cityList: [],
            townList: [],
            addressData: {},
            formData: {
                province: '',
                city: '',
                town: ''
            }
        }
    },
    watch: {
        'formData.province': function (val) {
            if (!val) {
                return false
            }
            getTerritory(val).then(res => {
                if (!res.data.success) {
                    return false
                }
                this.cityList = res.data.list
                if (!Object.keys(this.addressData).includes('province')) {
                    this.formData.city = ''
                    this.formData.town = ''
                } else {
                    delete this.addressData.province
                }
            })
        },
        'formData.city': function (val) {
            if (!val) {
                return false
            }
            getTerritory(val).then(res => {
                if (!res.data.success) {
                    return false
                }
                this.townList = res.data.list
                if (!Object.keys(this.addressData).includes('city')) {
                    this.formData.town = ''
                } else {
                    delete this.addressData.city
                }
            })
        }
    },
    methods: {
        initAddress (res) {
            if (!res) {
                res = { data: { obj: {} } }
            }
            this.addressData = Object.assign({}, res.data.obj)
            let obj = {
                provinceList: null,
                cityList: this.formData.province,
                townList: this.formData.city
            }
            Object.keys(obj).forEach((key, i) => {
                if (i !== 0 && !obj[key]) {
                    this[key] = []
                    return
                }
                getTerritory(obj[key]).then(res => {
                    this[key] = res.data.list
                })
            })
        }
    }
}
